import styled from 'styled-components';

const SlideNews = styled.div`
  p {
    hyphens: auto;
  }

  @media only screen and (min-width: 768px) {
    button {
      align-self: flex-end;
      padding: 4rem;
    }
  }
`;

export default SlideNews;
